// extracted by mini-css-extract-plugin
export var activeDot = "_5k-c";
export var buttonContainer = "_5k-9";
export var channelButton = "_5k-a";
export var clickable = "_5k-d";
export var content = "_5k-0";
export var contentFull = "_5k-2";
export var contentThird = "_5k-1";
export var contentWrapper = "_5k-7";
export var description = "_5k-5";
export var heightShort = "_5k-f";
export var image = "_5k-3";
export var imageContainer = "_5k-4";
export var selectButton = "_5k-e";
export var spinnerContainer = "_5k-b";
export var titleContent = "_5k-8";
export var titleWrapper = "_5k-6";